import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptBill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconReceiptBill"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V22.5291L16.7204 19.9901L14.3333 22.2919L12 20.0419L9.66667 22.2919L7.27961 19.9901L4 22.5291V2ZM8 7H16V8.5H8V7ZM8 11H12V12.5H8V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptBill;
